import { Box } from "arkh";
import React from "react";

export function DescriptionContentContainer(props: {
  description: React.ReactNode;
  media: React.ReactNode;
  files: React.ReactNode;
}) {
  return (
    <>
      {props.description}
      {props.description && (props.media || props.files) ? (
        <Box spaceTop="medium" />
      ) : null}
      {props.media}
      {props.files}
    </>
  );
}
